module.exports = __webpack_public_path__ + "assets/img/bottom-menu-bg.db700e5f.png";